import { render, staticRenderFns } from "./shortAnswerTM.vue?vue&type=template&id=65fbe904&scoped=true&"
import script from "./shortAnswerTM.vue?vue&type=script&lang=js&"
export * from "./shortAnswerTM.vue?vue&type=script&lang=js&"
import style0 from "./shortAnswerTM.vue?vue&type=style&index=0&id=65fbe904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fbe904",
  null
  
)

export default component.exports